import {
  ICreateNewsRequest,
  ICreateNewsResponse,
  INewsGetRequestParams,
  INewsGetResponse,
  INewsGetResponsePaginated,
  IUpdateNewsRequest,
  TUpdateStatus,
} from 'shared/types/news.types';
import { IdResponse } from 'shared/types/types';
import { edpApiV1 } from './index';

export const newsApi = edpApiV1.injectEndpoints({
  endpoints: build => ({
    getNews: build.query<INewsGetResponsePaginated, INewsGetRequestParams>({
      query: params => ({ url: '/v1/moderator/ads/news', method: 'GET', params }),
      providesTags: ['news'],
    }),
    getNewsById: build.query<INewsGetResponse, INewsGetRequestParams>({
      query: params => ({ url: '/v1/moderator/ads/newsById', method: 'GET', params }),
      providesTags: ['news'],
    }),
    updateNews: build.mutation<ICreateNewsResponse, IUpdateNewsRequest>({
      query: news => ({
        url: `/v1/moderator/ads/news`,
        method: 'PATCH',
        body: news,
      }),
      invalidatesTags: ['news'],
    }),
    createNews: build.mutation<ICreateNewsResponse, ICreateNewsRequest>({
      query: body => ({
        url: `/v1/moderator/ads/news`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['news'],
    }),
    updateStatus: build.mutation<ICreateNewsResponse, TUpdateStatus>({
      query: body => ({
        url: `/v1/moderator/ads/news_status`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['news'],
    }),
    resetRetry: build.mutation<ICreateNewsResponse, IdResponse>({
      query: body => ({
        url: `/v1/moderator/ads/news_reset_retry`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['news'],
    }),
  }),
  overrideExisting: false,
});

export const {
  useCreateNewsMutation,
  useGetNewsQuery,
  useLazyGetNewsQuery,
  useUpdateNewsMutation,
  useGetNewsByIdQuery,
  useLazyGetNewsByIdQuery,
  useResetRetryMutation,
  useUpdateStatusMutation,
} = newsApi;
